// [SPRINT K P1] Escrow store — localStorage mirror du backend escrow.
const KEY = (uid) => `aya_escrow_${String(uid || 'anon')}`;

export function loadEscrows(uid) {
  try { return JSON.parse(localStorage.getItem(KEY(uid)) || '[]') || []; }
  catch (_) { return []; }
}

export function saveEscrow(uid, entry) {
  const list = loadEscrows(uid);
  const idx = list.findIndex((e) => e.id === entry.id);
  if (idx >= 0) list[idx] = entry; else list.push(entry);
  try { localStorage.setItem(KEY(uid), JSON.stringify(list)); } catch (_) { /* non-fatal */ }
  return list;
}

const _api = { loadEscrows, saveEscrow };
export default _api;
